/**
 * FlowupLabels - Vanilla JS replacement for jQuery FlowupLabels plugin.
 * Adds 'focused' and 'populated' classes to form groups for floating label effects.
 */
function initFlowupLabels(selector, options) {
  const defaults = {
    feature_onInitLoad: true,
    class_focused: 'focused',
    class_populated: 'populated'
  };
  const settings = Object.assign({}, defaults, options);

  function getGroup(el) {
    return el.closest('.form-row, .form-group, .floating_input');
  }

  function refresh(input) {
    const group = getGroup(input);
    if (!group) return;
    let isAutofilled = false;
    try { isAutofilled = input.matches(':-webkit-autofill, :autofill'); } catch (e) {}
    if (input.value.length || isAutofilled) {
      group.classList.add(settings.class_populated);
    } else {
      group.classList.remove(settings.class_populated);
    }
  }

  document.querySelectorAll(selector).forEach(function(form) {
    form.addEventListener('focusin', function(e) {
      if (e.target.matches('.input-text, .form-control')) {
        var group = getGroup(e.target);
        if (group) group.classList.add(settings.class_focused);
      }
    });

    form.addEventListener('focusout', function(e) {
      if (e.target.matches('.input-text, .form-control')) {
        var group = getGroup(e.target);
        if (!group) return;
        group.classList.remove(settings.class_focused);
        refresh(e.target);
      }
    });

    // Covers autofill chosen from the browser suggestion dropdown and any
    // programmatic value changes — when a user selects an autofill suggestion
    // the browser fires 'input'/'change' on the filled fields, so the floating
    // label lifts without needing any :-webkit-autofill CSS hook (which
    // interferes with Chrome's first-fill after a page load).
    form.addEventListener('input', function(e) {
      if (e.target.matches('.input-text, .form-control')) refresh(e.target);
    });
    form.addEventListener('change', function(e) {
      if (e.target.matches('.input-text, .form-control')) refresh(e.target);
    });

    if (settings.feature_onInitLoad) {
      form.querySelectorAll('.input-text, .form-control').forEach(function(input) {
        refresh(input);
      });
    }
  });
}
